const OAUTH_CSRF_TOKEN_KEY = "oauth_csrf_token";

export function generateOAuthState(redirectTo: string): string {
  const csrfToken = crypto.randomUUID();
  sessionStorage.setItem(OAUTH_CSRF_TOKEN_KEY, csrfToken);

  return btoa(JSON.stringify({ csrfToken, redirectTo }));
}

export function validateOAuthState(
  encodedState: string | null,
): { redirectTo: string } | null {
  if (!encodedState) return null;

  try {
    const { csrfToken, redirectTo } = JSON.parse(atob(encodedState));
    const storedToken = sessionStorage.getItem(OAUTH_CSRF_TOKEN_KEY);
    sessionStorage.removeItem(OAUTH_CSRF_TOKEN_KEY);

    if (!storedToken || storedToken !== csrfToken) return null;

    return { redirectTo: redirectTo || "/subscriptions" };
  } catch {
    sessionStorage.removeItem(OAUTH_CSRF_TOKEN_KEY);
    return null;
  }
}
